module.exports = __webpack_public_path__ + "src/assets/img/to-draw-page.4ad2d6d2.png";